/**
 * Compose a React key + map-lookup key for an item that came from the
 * merged `/api/welcome/briefing` feed.
 *
 * The feed unions five collections (commitments, tasks, payments, calls,
 * reading). Two items from different collections that happen to share a
 * Mongo ObjectId string would collide as React keys — silently rendering
 * only one of them and triggering the dev-mode warning:
 *
 *   "Encountered two children with the same key, `<oid>`. Keys should be
 *    unique so that components maintain their identity across updates."
 *
 * It also breaks per-row `busyIds[item.id]` style maps: marking one
 * collection's row as "busy" would mark a same-id row from another
 * collection as busy too.
 *
 * Composing `${itemType}:${id}` is enough to guarantee uniqueness across
 * the union. Demo / fallback rows pass `itemType: null` — those already
 * carry unique synthetic ids (a1..a4 / b1..b4 / c1..c4) so the bare id
 * is fine for them.
 */
export function briefingItemKey(item) {
  if (!item || item.id == null) return 'briefing-item-unknown';
  return item.itemType ? `${item.itemType}:${item.id}` : String(item.id);
}
